var PubSub;
(function (PubSub) {
    var events = {};
    function hasEvent(event) {
        return events.hasOwnProperty(event);
    }
    function subscribe(event, handler) {
        if (!hasEvent(event))
            events[event] = [];
        var index = events[event].push(handler) - 1;
        return function () { return delete events[event][index]; };
    }
    PubSub.subscribe = subscribe;
    function publish(event, data) {
        if (!hasEvent(event))
            return;
        events[event].forEach(function (handler) {
            handler(data || {});
        });
    }
    PubSub.publish = publish;
})(PubSub || (PubSub = {}));
//# sourceMappingURL=pubsub.js.map